import { render, staticRenderFns } from "./pedidoPorCobrar.vue?vue&type=template&id=8110dce2&"
import script from "./pedidoPorCobrar.vue?vue&type=script&lang=js&"
export * from "./pedidoPorCobrar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports